"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var jsx_runtime_1 = require("react/jsx-runtime");
var Icon_1 = tslib_1.__importDefault(require("../Icon"));
var PinSolid = function (props) {
    return ((0, jsx_runtime_1.jsx)(Icon_1.default, tslib_1.__assign({}, props, { children: (0, jsx_runtime_1.jsx)("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M37 72C37 41.04 62.04 16 93 16C123.96 16 149 41.04 149 72C149 114 93 176 93 176C93 176 37 114 37 72ZM93 92C105.15 92 115 82.1503 115 70C115 57.8497 105.15 48 93 48C80.8497 48 71 57.8497 71 70C71 82.1503 80.8497 92 93 92Z' }) })));
};
/**
 * @deprecated Use Icon from Antd
 * https://ant.design/components/icon/
 */
exports.default = PinSolid;
